import { Box, Flex, Text } from '@chakra-ui/react'
import { MoonIcon } from '@heroicons/react/24/outline'

interface Props {
  isPatientSelected?: boolean
}

export default function EmptyBanner({ isPatientSelected = false }: Props) {
  return (
    <Flex justify="center" mt={24}>
      <Flex flexDir="column" justify="center" h="full">
        <Flex justify="center" mb={2}>
          <Box color="blue.500" p={1} borderRadius="full">
            <MoonIcon style={{ width: '48px', height: '48px' }} />
          </Box>
        </Flex>
        <Text color="gray.500" fontSize="lg" textAlign="center">
          It&apos;s looking empty over here
        </Text>
        <Text color="gray.400" fontSize="sm" textAlign="center">
          {isPatientSelected
            ? 'Add a visit or a follow up from the action bar below'
            : 'Add a patient from the action bar below or find one using the search bar above'}
        </Text>
      </Flex>
    </Flex>
  )
}
